module.exports = __webpack_public_path__ + "static/media/3.848b0051.gif";